<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 300px">
      <div class="left-top" @click="onAdd()">
        <div class="flex-1 font-16-30313a">工程进度模板</div>
        <div class="tip-20-bg-30313a">
          <i class="el-icon-plus font-bold"></i>
        </div>
      </div>
      <el-scrollbar class="hide-x h-100" v-if="menuList.length>0">
        <div  id="cateMenu">
          <div v-for="(item, index) in menuList" :key="index" class="menu-item" :class="{'is-active': chooseMenuIndex === index}">
            <div class="flex align-center pl-20 menu-body" @click="onChooseMenu(item, index)">
              <div class="index-tip">{{index + 1}}</div>
              <div class="menu-title-big">{{item.name}}</div>
              <div class="btn-container align-center">
                <i class="el-icon-edit mr-5" @click.stop="onEdit(item)"></i>
                <i class="el-icon-circle-close" @click.stop="onDelete(item)"></i>
                <div class="flex align-center" @click="onEnable(item)">
                  <img :src="item.isEnable ===1 ? '/static/images/xuanzhong.png':'/static/images/weixuan.png'" class="icon-16 ml-5" alt="">
                  <div class="font-12-30313a ml-5">启用</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0 ptb-10 mlr-10">
      <div class="flex content-top">
        <div class="flex-1 bg-ff h-100 flex align-center">
          <div class="flex align-center ml-5 mr-20 cursor">
            <div class="mr-5 decoration-line" ></div>
            <div class="font-bold font-16-f5971d" v-if="projectClassify">{{projectClassify.name}}</div>
          </div>
        </div>
      </div>
      <div class="mt-10 mb-5 flex flex-wrap">
        <div class="flex align-center mr-5 mb-5 btn-24-bg-ff" @click="addProjectDetail">
          <img src="/static/images/add.png" class="icon-14 mr-5" alt="">
          <div>添加</div>
        </div>
        <div class="flex align-center mr-5 mb-5 btn-24-bg-ff"  @click="deleteProjectDetail">
          <img src="/static/images/shanchu.png" class="icon-12-14 mr-5" alt="">
          <div>删除</div>
        </div>
      </div>
      <div style="height: 500px">
        <erp-table ref="erpTable" :is-edit="true" @on-switch="onChangeStatus"  :table-data="tableData" :loading="loading" :column-data="columnData" @on-check="onCheck" @on-modify="onModifyRow" modify-method="on-modify"></erp-table>
      </div>
    </div>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="500px" title="工程进度模板" :visible.sync="modelShow" @closed="onCloseClassify">
      <div class="p-20">
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">工程进度名称：</div>
          <el-input v-model="newClassify.name" class="flex-1" placeholder="请输入工程进度名称"></el-input>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5 flex">是否启用：</div>
          <div class="flex mt-5">
            <el-radio v-model="newClassify.isEnable" label="1">是</el-radio>
            <el-radio v-model="newClassify.isEnable" label="0">否</el-radio>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseClassify">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="onSubmitClassify">确定</div>
      </div>
    </el-dialog>
    <!---->
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="500px" title="添加分项工程详情" :visible.sync="modelDetailShow" @closed="onCloseDetail">
      <div class="p-20">
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">名称：</div>
          <el-input v-model="modelDetail.name" class="flex-1" placeholder="请输入名称"></el-input>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">提醒：</div>
          <div class="flex  align-center ">
            <el-switch
              v-model="modelDetail.remind"
              active-color="#13ce66"
              inactive-color="#f3f4f7">
            </el-switch>
          </div>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">工序：</div>
          <el-input v-model="modelDetail.sort" type="number" class="flex-1" placeholder="请输入工序"></el-input>
        </div>
        <div class="flex mb-10">
          <div class="font-12-30313a mr-5">备注：</div>
          <el-input type="textarea" v-model="modelDetail.remark" :row="3" class="flex-1" placeholder="请输入备注"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseDetail">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="onSubmitDetail">确定</div>
      </div>
    </el-dialog>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="526px" title="设置验收标准" :visible.sync="standardShow" @closed="onCloseStandard">
      <div class="p-20">
        <div class="flex align-center">
          <img src="/static/images/jinggao.png" class="icon-14 mr-5" alt="">
          <div class="font-12-30313a">提示：您正在设置<span class="font-12-ff5555 mlr-5">{{modelDetailList.name}}</span>的验收标准</div>
        </div>
        <div class="mt-10 mb-5 flex flex-wrap">
          <div class="flex align-center mr-5 mb-5 btn-24-bd-e2-bg-ff" @click="addStandard">
            <img src="/static/images/add.png" class="icon-14 mr-5" alt="">
            <div>添加</div>
          </div>
          <div class="flex align-center mr-5 mb-5 btn-24-bd-e2-bg-ff"  @click="deleteStandard">
            <img src="/static/images/shanchu.png" class="icon-12-14 mr-5" alt="">
            <div>删除</div>
          </div>
        </div>
        <div class="flex-1" style="height: 300px">
          <erp-table ref="standardTable" :is-edit="true" :table-data="standardData" :loading="loading" :column-data="columnStandard" @on-modify="onModifyStandard" modify-method="on-modify"></erp-table>
        </div>
      </div>
    </el-dialog>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="500px" title="添加验收标准" :visible.sync="addStandardShow" @closed="onCloseAddStandard">
      <div class="p-20">
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">验收名称：</div>
          <el-input v-model="standard.name" class="flex-1" placeholder="请输入验收名称"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onCloseAddStandard">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="onSubmitStandard">确定</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import MoveHorizon from '../../components/MoveHorizon'
import ErpTable from '../../components/ErpTable'
export default {
  name: 'projectProgressDefine',
  components: {MoveHorizon, ErpTable},
  data () {
    return {
      chooseMenuIndex: 0,
      projectClassify: {},
      loading: false,
      menuList: [],
      columnData: [
        {
          type: 'selection',
          width: '40',
          fixed: 'left'
        },
        {
          field: 'operate', // 若为操作，则固定为operate
          title: '验收标准',
          width: '120',
          fixed: 'left',
          isDefine: true,
          child: [{
            type: 'btn',
            className: 'btn-16-bg-85 btn-hover',
            title: '验收标准',
            methodName: 'on-check'
          }]
        },
        {
          field: 'remind',
          title: '提醒',
          width: '60',
          isDefine: true,
          child: [{
            title: '是',
            key: 'remind',
            methodName: 'on-switch',
            type: 'switch',
            activeValue: 1,
            inactiveValue: -1
          }]
        },
        {
          field: 'sort',
          title: '工序',
          width: '55',
          methodName: 'on-change-sort',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'name',
          title: '分项工程名称',
          minWidth: '160',
          methodName: 'on-change-name',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'remark',
          title: '备注',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }
      ],
      tableData: [],
      modelShow: false,
      standardShow: false,
      modelDetailShow: false,
      addStandardShow: false,
      newClassify: {
        name: '',
        isEnable: '1'
      },
      editItem: {},
      modelDetail: {
        name: '',
        sort: '',
        remind: true,
        remark: ''
      },
      columnStandard: [
        {
          type: 'selection',
          width: '40',
          fixed: 'left'
        },
        {
          type: 'index',
          title: '序号',
          width: '60',
          fixed: 'left'
        },
        {
          field: 'name',
          title: '验收名称',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }
      ],
      standardData: [],
      modelDetailList: {},
      standard: {
        name: ''
      }
    }
  },
  created () {
    this.getTemplate()
  },
  mounted () {},
  methods: {
    getTemplate () {
      let params = {
        companyId: this.$store.state.companyId
      }
      this.axios.post('progressTemplate/list', params).then(res => {
        if (res.data.success) {
          this.menuList = res.data.data
          this.projectClassify = this.menuList[0]
          this.getTemplateDetail()
        }
      })
    },
    getTemplateDetail () {
      let params = {
        progressId: this.projectClassify.id
      }
      this.axios.post('progressDetailTemplate/list', params).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data
        }
      })
    },
    getStandard () {
      let params = {
        detailId: this.modelDetailList.id
      }
      this.axios.post('progressStandardTemplate/list', params).then(res => {
        if (res.data.success) {
          this.standardData = res.data.data
        }
      })
    },
    onAdd () {
      this.modelShow = true
    },
    onChooseMenu (menu, index) {
      this.projectClassify = menu
      this.chooseMenuIndex = index
      this.getTemplateDetail()
    },
    onEdit (item) {
      this.newClassify.name = item.name
      this.newClassify.isEnable = item.isEnable + ''
      this.editItem = item
      this.modelShow = true
    },
    onDelete (item) {
      let params = {
        id: item.id
      }
      this.axios.post('progressTemplate/deleteById', this.qs.stringify(params)).then(res => {
        if (res.data.success) {
          this.$message({
            message: '删除工程进度模板成功',
            type: 'success'
          })
          this.modelShow = false
          this.getTemplate()
        }
      })
    },
    onEnable (row) {
      let params = {
        id: row.id
      }
      if (row.isEnable === 1) {
        params.isEnable = 0
      } else {
        params.isEnable = 1
      }
      this.axios.post('progressTemplate/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.modelShow = false
          this.getTemplate()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChangeStatus (row) {
      this.onModifyRow(row, true, 'remind')
    },
    onSubmitClassify () {
      if (JSON.stringify(this.editItem) === '{}') {
        this.saveSub()
      } else {
        this.editSub()
      }
    },
    saveSub () {
      let params = {
        name: this.newClassify.name,
        isEnable: this.newClassify.isEnable,
        companyId: this.$store.state.companyId
      }
      if (this.newClassify.name) {
        this.axios.post('progressTemplate/save', params).then(res => {
          if (res.data.success) {
            this.$message({
              message: '添加工程进度模板成功',
              type: 'success'
            })
            this.modelShow = false
            this.getTemplate()
          }
        })
      } else {
        this.$message.error('工程进度名称不能为空哟')
      }
    },
    editSub () {
      let params = {
        id: this.editItem.id,
        name: this.newClassify.name,
        isEnable: this.newClassify.isEnable
      }
      this.axios.post('progressTemplate/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.modelShow = false
          this.getTemplate()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onSubmitDetail () {
      this.modelDetail.progressId = this.projectClassify.id
      if (this.modelDetail.remind) {
        this.modelDetail.remind = 1
      } else {
        this.modelDetail.remind = -1
      }
      if (!this.modelDetail.name) {
        this.$message.warning('请输入分项工程名称')
      } else if (!this.modelDetail.sort) {
        this.$message.warning('请输入工序')
      } else {
        this.axios.post('progressDetailTemplate/save', this.modelDetail).then(res => {
          if (res.data.success) {
            this.modelDetailShow = false
            this.getTemplateDetail()
            this.modelDetail = {
              name: '',
              sort: '',
              remind: true,
              remark: ''
            }
            this.$message({
              message: '添加分项工程进度成功',
              type: 'success'
            })
          }
        })
      }
    },
    addProjectDetail () {
      this.modelDetailShow = true
    },
    deleteProjectDetail () {
      let customerArr = this.$refs.erpTable.getSelectEvent()
      if (customerArr.length === 0) {
        this.$message({
          message: `请先选择一个标准`,
          type: 'warning'
        })
      } else {
        console.log(customerArr)
        let idArr = []
        for (let i = 0; i < customerArr.length; i++) {
          idArr.push(customerArr[i].id)
        }
        let params = {
          ids: idArr.join(',')
        }
        this.axios.post('progressDetailTemplate/deleteByIds', this.qs.stringify(params)).then(res => {
          if (res.data.success) {
            this.getTemplateDetail()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
          }
        })
      }
    },
    onModifyRow (row, cloumn, colName) {
      let params = null
      if (row) {
        params = {
          id: row.id,
          [colName]: row[colName]
        }
      }
      this.axios.post('progressDetailTemplate/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.getTemplateDetail()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onSubmitStandard () {
      this.standard.detailId = this.modelDetailList.id
      if (!this.standard.name) {
        this.$message.warning('请输入验收名称')
      } else {
        this.axios.post('progressStandardTemplate/save', this.standard).then(res => {
          if (res.data.success) {
            this.addStandardShow = false
            this.getStandard()
            this.$message({
              message: '添加验收标准成功',
              type: 'success'
            })
            this.standard.name = ''
          }
        })
      }
    },
    addStandard () {
      this.addStandardShow = true
    },
    onModifyStandard (row, cloumn, colName) {
      let params = null
      if (row) {
        params = {
          id: row.id,
          [colName]: row[colName]
        }
      }
      this.axios.post('progressStandardTemplate/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.getStandard()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    deleteStandard () {
      let customerArr = this.$refs.standardTable.getSelectEvent()
      if (customerArr.length === 0) {
        this.$message({
          message: `请先选择一个标准`,
          type: 'warning'
        })
      } else {
        let idArr = []
        for (let i = 0; i < customerArr.length; i++) {
          idArr.push(customerArr[i].id)
        }
        let params = {
          ids: idArr.join(',')
        }
        this.axios.post('progressStandardTemplate/deleteByIds', this.qs.stringify(params)).then(res => {
          if (res.data.success) {
            this.getStandard()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
          }
        })
      }
    },
    onCloseClassify () {
      this.modelShow = false
      this.newClassify = {}
    },
    onCloseStandard () {
      this.standardShow = false
    },
    onCloseAddStandard () {
      this.standard.name = ''
      this.addStandardShow = false
    },
    onCloseDetail () {
      this.modelDetailShow = false
      this.modelDetail = {
        name: '',
        sort: '',
        remind: true,
        remark: ''
      }
    },
    onCheck (row) {
      this.standardShow = true
      this.modelDetailList = row
      this.getStandard()
    }
  }
}
</script>

<style lang="scss" scoped>
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .dialog-left-top {
    height: 40px;
    border-bottom: 1px solid #e2e2e2;
    line-height: 40px;
    padding: 0 20px;
    font-size: 16px;
    color: #30313a;
    text-align: left;
    background-color: #ffffff;
  }
  .dialog-menu-item {
    height: 35px;
    line-height: 35px;
    display: flex;
    padding: 0 20px;
    font-size: 12px;
    color: #30313a;
    text-align: left;
    cursor: pointer;
    &.active {
      color: #f5971d;
    }
    &.current {
      color: #f5971d;
      background: #f3f4f7;
    }
  }
  .hide-x {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  }
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      line-height: 30px;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #f5971d;
      }
    }
  }
  #cateMenu {
    height: 100%;
    width: 100%;
    min-width: 200px;
    background: #fff;
    overflow-y: auto;
    .menu-item {
      min-height: 35px;
      border-bottom: dashed 1px #e2e2e2;
      line-height: 35px;
      .index-tip {
        width: 20px;
        text-align: center;
        height: 14px;
        line-height: 14px;
        background-color: #b9b9b9;
        border-radius: 4px;
        font-size: 10px;
        color: #ffffff;
        margin-right: 5px;
      }
      .menu-title-big {
        flex: 1;
        overflow-x: hidden;
        font-size: 14px;
        color: #30313a;
        word-break: keep-all;
        text-align: left;
      }
      .btn-container {
        padding: 0 10px;
        display: flex;
        align-items: center;
        i {
          font-size: 14px;
          color: #e2e2e2;
        }
      }
      &.is-open{
        background-color: #f3f4f7;
        .index-tip {
          background-color: #f5971d;
        }
        .menu-title-big {
          color: #f5971d;
        }
      }
      &.is-active{
        .menu-body {
          color: #f5971d;
        }
        .index-tip {
          background-color: #f5971d;
          color: #ffffff;
        }
        .menu-title-big {
          color: #f5971d;
        }
      }
      .menu-body:hover, &.is-active .menu-body {
        cursor: pointer;
        .btn-container {
          i {
            color: #30313a;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/projectProgressDefine.vue